import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useBookingsContext } from '../../../contexts/BookingsContext';
import { COLORS } from '../../../utils/colors';
import CalendarEvents from '../CalendarEvents';
import { IBooking } from '@homeporter/types';
import { useCalendarStyles } from './styles';

interface BookingEvent {
  bookings: IBooking[];
}

interface IEvent {
  start: Date;
  end: Date;
  title: string;
  details?: IBooking;
}

interface IScheduleCalendar {
  firstVisit: boolean;
}

const ScheduleCalendar = ({ firstVisit }: IScheduleCalendar) => {
  console.log('::::ScheduleCalendar...');
  const styles = useCalendarStyles();
  const { bookings, isFetchingBookings } = useBookingsContext();

  const [events, setEvents] = useState<IEvent[]>([]);

  useEffect(() => {
    const mapBookingsToEvents = (bookings: IBooking[]): IEvent[] => {
      return bookings.map((booking) => {
        const bookingDate = new Date(booking.booking_date);
        const durationInMinutes = booking.session_duration || 0;
        const durationInMilliseconds = durationInMinutes * 60000;
        const endDate = new Date(
          bookingDate.getTime() + durationInMilliseconds,
        );

        return {
          start: bookingDate,
          end: endDate,
          title: booking.payment?.plan?.label || 'No title provided',
          details: booking,
        };
      });
    };

    setEvents(mapBookingsToEvents(bookings));
  }, [bookings]);

  return (
    <>
      {isFetchingBookings && (
        <Box sx={styles.progress}>
          <CircularProgress sx={{ color: COLORS.PRIMARY }} />
        </Box>
      )}
      <CalendarEvents events={events} />
    </>
  );
};

export default ScheduleCalendar;
